import api from '@api/Api';

export default {

    acceptMemberInvite(token) {
        return api().post(`/member-invites/${token}/accept`);
    },

    resendMemberInvite(id) {
        return api().post(`/member-invites/${id}/resend`);
    },

    deleteMemberInvite(id) {
        return api().delete(`/member-invites/${id}`);
    },

}
